module.exports = __webpack_public_path__ + "img/logo-bayton-hr-white.b840c0e8.svg";